import React from "react";
import PropTypes from 'prop-types';

class CustomizedXAxisTick extends React.Component {

  render () {
    const {x, y, payload} = this.props;
    return (
      <g transform={ `translate(${x},${y})` }>
        <path
          id="vendor-text-path"
          fill="none"
          stroke="white"
          d={ `M ${ -(this.props.width/(this.props.sibilings * 3)) } 8 l ${ (this.props.width/(this.props.sibilings * 1.5)) } 0` }
        />
        <text fontSize="13" fill="rgb(102, 102, 102)">
          <textPath xlinkHref="#vendor-text-path">
            <tspan>
              {payload.value}
            </tspan>
          </textPath>
        </text >
      </g>
    );
  }
}

CustomizedXAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  payload: PropTypes.object,
  sibilings: PropTypes.number
};

export default CustomizedXAxisTick;


// WEBPACK FOOTER //
// ./src/components/dashboard/comp/vendorOverchargesChart/CustomizedXAxisTick.js